import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Badge, Button, Col, Row, Table } from 'react-bootstrap'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import Error_false from '../../../components/error/error-false'
import SwalCustomSuccess from '../../../alert/swal-success'
import { fnDateEn } from '../../../helper/fnDateEn'
import SwalCustom from '../../../alert/swal-custom'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import ModalMoreFilter from './ModalMoreFilter'
import { BsArrowClockwise, BsSearch, BsSliders2Vertical } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { PAGE_INCOME_PAYROLL_PRINT_DETAIL } from '../../../router/routes'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import {
  listGroupPayrollAPI,
  printPayrollAPI
} from '../../../services/income/payroll'
import { FaPrint } from 'react-icons/fa6'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import { values } from 'lodash'
import ButtonExportExcel from './ButtonExportExcel'

export default function IncomePayrollPrintPage() {
  const totalLimits = 20
  const orgId = useSelector((state) => state.roleReducer.role)

  const [totalRows, setTotalRow] = useState(0)
  const [page, setPage] = useState(1)
  const [showFilter, setShowFilter] = useState({ isShow: false, data: null })
  const [dataTable, setDataTable] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [selectMonth, setSelectMonth] = useState()

  useEffect(() => {
    const body = {
      page: 1,
      orgId
      //   paymentPeriodDate: fnDateEn(selectMonth).format('YYYYMM')
    }

    if (orgId) {
      fnGetData(body)
    }
  }, [orgId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setPage(body.page)
    setBodyFilter(body)
    const resp = await listGroupPayrollAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnPrintData = (d) => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, print it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const body = {
          orgId: d.orgId,
          paymentPeriodDate: fnDateEn(d.paymentPeriodDate).format('YYYYMM')
        }
        const resp = await printPayrollAPI(body)
        if (!resp) return
        if (resp.status) {
          SwalCustomSuccess().then(() => {
            fnGetData(bodyFilter)
          })
        } else {
          Error_false(resp)
        }
      }
    })
  }

  return (
    <>
      <NavTitle>
        <TextNavTitle>Payroll Print</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3">
            <Row>
              <Col md={4} className="my-auto small">
                <label>Total: {totalRows.toLocaleString()}</label>
              </Col>

              <Col md={8} className="gap-3 d-flex justify-content-end">
                <div style={{ width: 200 }}>
                  <AutocompleteCustom
                    placeholder="Active Status"
                    className="w-100"
                    isClearable={true}
                    options={[
                      { label: 'Waiting', value: 0 },
                      { label: 'Printed', value: 1 }
                    ]}
                    onChange={(d) => {
                      const body = {
                        ...bodyFilter,
                        page: 1,
                        printStatus: d?.value ?? ''
                      }
                      fnGetData(body)
                    }}
                  />
                </div>
                <div style={{ width: 200 }}>
                  <CustomDatePicker
                    value={selectMonth}
                    showYearDropdown
                    isClearable={true}
                    placeholderText="Periods"
                    // renderMonthContent={renderMonthContent}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    onChange={(d) => {
                      if (d) {
                        const body = {
                          ...bodyFilter,
                          page: 1,
                          paymentPeriodDate: fnDateEn(d).format('YYYYMM')
                        }
                        fnGetData(body)
                      } else {
                        const body = {
                          ...bodyFilter,
                          page: 1,
                          paymentPeriodDate: ''
                        }
                        fnGetData(body)
                      }
                      setSelectMonth(d)
                    }}
                  />
                </div>
                {/* <Button
                  className="px-4 text-primary"
                  variant="light"
                  onClick={() => {
                    setShowFilter({ isShow: true, data: null })
                  }}
                >
                  <BsSliders2Vertical className="me-2" />
                  More Filter
                </Button> */}
                {/* <Button
                  className=""
                  variant="light"
                  onClick={() => {
                    const body = {
                      orgId,
                      page: 1
                    }
                    fnGetData(body)
                  }}
                >
                  <BsArrowClockwise />
                </Button> */}
              </Col>
            </Row>
          </div>

          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>

                <th className="fw-normal">Periods</th>

                <th className="text-center fw-normal">Status</th>
                <th className="fw-normal">Status Update By</th>
                <th className="fw-normal">Status Update Date</th>
                <th className="fw-normal ">Insert By</th>
                <th className="fw-normal ">Insert Date</th>
                <th className="text-center fw-normal">Action</th>
              </tr>
            </thead>

            <tbody className="text-break fw-light">
              {isLoading ? (
                <TableSkeletonBody colSpan={8} rowSpan={7} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>

                    <td className="">
                      {fnDateEn(d.paymentPeriodDate).format('MM/YYYY')}
                    </td>

                    <td className="text-center">
                      <Badge bg={d.printStatus ? 'primary' : 'warning'}>
                        {d.printStatus ? 'Printed' : 'Waiting'}
                      </Badge>
                    </td>
                    <td className="">{d.printBy ?? '-'}</td>
                    <td className="">
                      {d.printDate
                        ? fnDateEn(d.printDate).format('DD/MM/YYYY HH:mm')
                        : '-'}
                    </td>
                    <td className="">{d.insertBy}</td>

                    <td className="">
                      {fnDateEn(d.insertDate).format('DD/MM/YYYY HH:mm')}
                    </td>

                    <td className="text-center">
                      <Link
                        className="btn btn-primary btn-sm me-2"
                        to={`${PAGE_INCOME_PAYROLL_PRINT_DETAIL}?id=${d.paymentPeriodDate}&orgId=${d.orgId}`}
                      >
                        <BsSearch />
                      </Link>

                      <ButtonExportExcel
                        bodyFilter={{
                          orgId: d.orgId,
                          paymentPeriodDate: fnDateEn(
                            d.paymentPeriodDate
                          ).format('YYYYMM'),
                          searchs: ''
                        }}
                      />

                      <Button
                        disabled={d.printStatus}
                        size="sm"
                        variant="light"
                        className="text-primary "
                        onClick={() => fnPrintData(d)}
                      >
                        <FaPrint />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="font-small-2 align-middle">
                  <td colSpan={8} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showFilter.isShow && (
        <ModalMoreFilter
          bodyFilter={bodyFilter}
          fnGetData={(body) => fnGetData({ ...bodyFilter, ...body })}
          onCancel={() => setShowFilter({ isShow: false, data: null })}
          open={showFilter.isShow}
        />
      )}
    </>
  )
}
